module.exports = __webpack_public_path__ + "img/fabric-trading.ee736b90.svg";